import { useMembership } from '@ocx/data-membership';
import { useGeolocation } from '@ocx-app/lib/geolocation/useGeolocation';
import { ScreenLoader } from '@ocx/ui';

import { createIframeUrl } from './order-ahead-provider.vroom.utils';
import { useVroomStorage } from './use-vroom-storage.hook';

type OrderAheadProviderVroomProps = {
  iframeUrlTemplate: string;
};
export const OrderAheadProviderVroom = (props: OrderAheadProviderVroomProps) => {
  const { iframeUrlTemplate } = props;
  const {
    membership: { id: membershipId },
  } = useMembership();

  const { isLoading: isSessionLoading, lastVisitedUrl } = useVroomStorage({ membershipId, iframeUrlTemplate });
  const { loading: isLocationLoading, coordinates } = useGeolocation();

  if (isLocationLoading || isSessionLoading) {
    return <ScreenLoader />;
  }

  const iframeUrl =
    lastVisitedUrl ||
    createIframeUrl({
      membershipId,
      urlTemplate: iframeUrlTemplate,
      location: coordinates,
    });

  return <iframe title="Order Ahead" src={iframeUrl} height="100%" width="100%" style={{ border: 'none' }} />;
};
